import * as Ariakit from '@ariakit/react';
import { Container } from './Container';
import { Details } from './Details';
import { Summary } from './Summary';
export function useExpansionPanelState() {
    const disclosure = Ariakit.useDisclosureContext();
    if (!disclosure) {
        throw new Error('You must use `useExpansionPanelState` within a `ExpansionPanel.Container`.');
    }
    const state = Ariakit.useStoreState(disclosure);
    return { ...disclosure, ...state };
}
export const ExpansionPanel = {
    Container,
    Details,
    Summary,
};
//# sourceMappingURL=index.js.map